import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Main from "../../../../layout/main/Main";
import { Space, Radio, Dropdown, Menu, Modal, Spin } from "antd";
import {
	CloseCircleOutlined,
	CloudDownloadOutlined,
	InfoCircleOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import {
	ActionButton,
	AntdRadioButton,
	FilterActions,
	FilterCard,
	FilterContainer,
	Filters,
	RadioOptions,
	TableContainer,
} from "./styles";
import LoadingHeader from "./components/LoadingHeader";
import Image from "../../../../common/image/Image";
import { FaImages } from "react-icons/fa";
import { COLORS, Typo } from "../../../../layout/theme";
import DropShadow from "../../../../common/drop-shadow/DropShadow";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import debounce from "lodash/debounce";
import { BsThreeDotsVertical } from "react-icons/bs";
import AntdSearch from "../../../../common/antd-search/AntdSearch";
import moment from "moment";
import {
	get_ia_plans,
	get_ia_plans_header_info,
	update_ia_plan_state,
} from "../../../../../api/endpoints/iaPlan";
import IAPlanTable from "./components/ia-plan-table/IAPlanTable";
import DataTable from "../../../../common/data-table/DataTable";
import PrimaryButton from "../../../../common/antd-buttons/PrimaryButton";

const { confirm } = Modal;

export default function IAPlanList() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		// {
		// 	title: (algo) => {
		// 		return <FaImages style={{ color: COLORS.White }} />;
		// 	},
		// 	width: 150,
		// 	dataIndex: "photoUrl",
		// 	render: (value, record, index) => (
		// 		<Image width={40} height={40} src={value} alt={record.title} />
		// 	),
		// },
		{
			title: () => <div style={{ color: COLORS.White }}>Nombre</div>,
			dataIndex: "title",
			render: (value, record) => (
				<Link
					to={`/admin/iaPlans/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Precio</div>,
			dataIndex: "planPrice",
			render: (value, record) => (
				<Link
					to={`/admin/iaPlans/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Tokens</div>,
			dataIndex: "tokenQty",
			render: (value, record) => (
				<Link
					to={`/admin/iaPlans/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Clientes</div>,
			dataIndex: "clients",
			render: (value, record) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{record.clients?.length ?? []}
				</Typo>
			),
		},
		{
			title: "",
			key: "id",
			dataIndex: "id",
			width: 10,
			render: (f, r, i) => (
				<>
					<Dropdown
						overlay={r.isActive ? menu : menuInactive}
						placement="bottomRight"
					>
						<ActionButton key={`${f}`} onMouseOver={() => setKey(r)}>
							<BsThreeDotsVertical />
						</ActionButton>
					</Dropdown>
				</>
			),
		},
	];

	const menu = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/iaPlans/${key.id}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleDelete(key)}>Desactivar</Typo>,
				},
			]}
		/>
	);

	const menuInactive = (
		<Menu
			items={[
				{
					key: "1",
					label: (
						<Link to={`/admin/iaPlans/${key.id}?uri=${uri}`}>
							<Typo type="secondary">Editar</Typo>
						</Link>
					),
				},
				{
					key: "2",
					label: <Typo onClick={() => handleActivate(key)}>Reactivar</Typo>,
				},
			]}
		/>
	);

	const fetch_ia_plans = async (search = "", skipValue = null) => {
		setLoading(true);
		try {
			const res = await get_ia_plans(search, state);

			setData(res);
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	const fetch_ia_plan_header = async () => {
		const res = await get_ia_plans_header_info();
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_ia_plan_header();
	}, [state]);

	useEffect(() => {
		fetch_ia_plans();
	}, [state]);

	useEffect(() => {
		return () => {
			debouncedEventHandler.cancel();
		};
	}, []);

	const eventHandler = (e) => {
		setSearchTerm(e.target.value);
		fetch_ia_plans(e.target.value);
	};

	const debouncedEventHandler = useMemo(() => debounce(eventHandler, 250), []);

	const handleDelete = (dist) => {
		confirm({
			title: "¿Seguro que quiere desactivar este plan?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "La desactivación del plan se aplicará de inmediato",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				handleDeleteSecondWarning(dist);
			},
		});
	};

	const handleDeleteSecondWarning = (dist) => {
		confirm({
			title:
				"Tenga en cuenta que al continuar con esta acción el plan quedará inaccesible en el sistema",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content: "Desea proceder de todas maneras?",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				deleteChain(dist);
			},
		});
	};

	const deleteChain = async (dist) => {
		setLoading(true);
		const _state = { id: dist.id, state: "INACTIVE" };
		await update_ia_plan_state(dist.id, _state);
		fetch_ia_plans();
		fetch_ia_plan_header();
		setLoading(false);
	};

	const handleActivate = (dist) => {
		confirm({
			title: "¿Seguro que quiere reactivar este plan?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "La reactivación del plan se aplicará de inmediato",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				activateTemplate(dist);
			},
		});
	};

	const activateTemplate = async (dist) => {
		setLoading(true);
		const _state = { id: dist.id, state: "ACTIVE" };
		await update_ia_plan_state(dist.id, _state);
		fetch_ia_plans();
		fetch_ia_plan_header();
		setLoading(false);
		// }
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Planes</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<FilterCard>
					<FilterContainer>
						<AntdSearch
							width={400}
							allowClear
							placeholder="Buscar plan"
							onChange={debouncedEventHandler}
							style={{ borderRadius: 15, height: 35 }}
						/>
						<RadioOptions>
							<Radio.Group
								value={state}
								onChange={(e) => setState(e.target.value)}
							>
								<AntdRadioButton value="ACTIVE">
									Activo ({headerInfo?.totalActive})
								</AntdRadioButton>
								<AntdRadioButton value="INACTIVE">
									Inactivo ({headerInfo?.totalInactive})
								</AntdRadioButton>
							</Radio.Group>
						</RadioOptions>
						<FilterActions>
							<PrimaryButton
								type="primary"
								bg="Primary"
								color="White"
								icon={<PlusOutlined />}
								onClick={() => navigate("/admin/iaPlans/create?uri=" + uri)}
								style={{ width: "200px", fontWeight: "400", height: 35 }}
							>
								Crear plan
							</PrimaryButton>
						</FilterActions>
					</FilterContainer>
				</FilterCard>
				<TableContainer>
					<IAPlanTable data={data} columns={columns} loading={loading} />
				</TableContainer>
			</Main.Body>
		</Main>
	);
}
